import {Injectable} from '@angular/core';
import {HttpErrorInterceptor as Base} from '@shared/interceptors/http-error-interceptor';

@Injectable()
export class HttpErrorInterceptor extends Base{
}
